import { ChangeEvent } from 'react';
import { useSearchParams } from 'react-router-dom';

interface SortFilterProps {
  sortBy: string;
}

export const SortFilter = ({ sortBy }: SortFilterProps) => {
  const [, setSearchParams] = useSearchParams();

  const handleUpdateSort = (event: ChangeEvent<HTMLSelectElement>) => {
    setSearchParams((currentSearchParams: URLSearchParams): URLSearchParams => {
      currentSearchParams.set('sort', event.target.value);
      return currentSearchParams;
    });
  };

  return (
    <div className="search-info-sort-wrapper">
      <label>Sort by</label>
      <select value={sortBy} onChange={handleUpdateSort}>
        <option value="relevance">Relevance</option>
        <option value="date">Date</option>
      </select>
    </div>
  );
};
